{
  "es": {
    "chart": {
      "labels": {
        "view": {
          "one": "%{label}:<br><b>%{count}</b> Vista",
          "other": "%{label}:<br><b>%{count}</b> Vistas"
        },
        "ship": {
          "one": "%{label}:<br><b>%{count}</b> Nave",
          "other": "%{label}:<br><b>%{count}</b> Naves"
        },
        "ship-pie": {
          "one": "%{label}:<br><b>%{count}</b> Nave (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Naves (%{percentage} %)"
        },
        "component-pie": {
          "one": "%{label}:<br><b>%{count}</b> Componente (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Componentes (%{percentage} %)"
        },
        "user": {
          "one": "%{label}:<br><b>%{count}</b> Usuario",
          "other": "%{label}:<br><b>%{count}</b> Usuarios"
        },
        "user-pie": {
          "one": "%{label}:<br><b>%{count}</b> User (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Users (%{percentage} %)"
        },
        "visit": {
          "one": "%{label}:<br><b>%{count}</b> Visita",
          "other": "%{label}:<br><b>%{count}</b> Visitas"
        }
      }
    }
  }
}
